import { UserModule } from '@/store/modules/user';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { Route } from 'vue-router';
import router from './index';
import RouterInterceptors from './interceptors';

NProgress.configure({ showSpinner: false });

router.beforeEach(async (to: Route, _: Route, next: any) => {
    // Start progress bar
    NProgress.start();
    if (UserModule.userToken) {
        next();
    } else {
        // 获取token
        await RouterInterceptors.getToken(next);
    }
    NProgress.done();
});

router.afterEach((to: Route) => {
    // Finish progress bar
    NProgress.done();
    // set page title
    document.title = to.meta.title;
});
